import { observeElement } from '@uvocore-front/utils';
/* eslint-disable  consistent-return */
import { isTouchDevice, isMobile } from '../../utils';

import './style.scss';

const priceTable = document.querySelector('.PriceTable');

const mobilePricingInit = () => {
  if (!priceTable) return;

  const select = priceTable.querySelector('[data-pricing-select]');
  const tabs = priceTable.querySelectorAll('[data-pricing-level]');

  const main = () => {
    const state = {
      current: 0,
    };

    const changeHandler = () => {
      tabs[state.current].style.display = 'none';
      tabs[select.value].style.display = 'block';
      state.current = select.value;
    };

    if (isMobile) {
      select.value = 0;
      select.addEventListener('change', changeHandler, false);
    } else {
      select.removeEventListener('change', changeHandler, false);

      [].slice.call(tabs).forEach((item) => {
        item.style.display = ''; // eslint-disable-line
      });
    }
  };

  main();
  window.addEventListener('orientationchange', main, false);
};

const pricingHoverInit = () => {
  if (!isTouchDevice) return false;

  const table = document.querySelector('.PriceTable');
  const cells = document.querySelectorAll('.PriceTable__list li');

  if (!table) {
    return false;
  }

  const mouseoverHandler = (e) => {
    Array.prototype.forEach.call(cells, (item) => {
      item.classList.remove('is-active');
    });

    let current;

    if (Array.prototype.indexOf.call(cells, e.target) !== -1) {
      current = Array.prototype.indexOf.call(e.target.parentNode.children, e.target);
    }

    Array.prototype.forEach.call(cells, (item) => {
      const indexOfParent = Array.prototype.indexOf.call(item.parentNode.children, item);

      if (indexOfParent === current) {
        item.classList.add('is-active');
      }
    });
  };

  table.addEventListener('mouseover', mouseoverHandler);
};

// Run
document.addEventListener('DOMContentLoaded', () => {
  if (priceTable) {
    observeElement({
      element: '.PriceTable',
      marginValue: 200,
      callback: () => {
        pricingHoverInit();
        mobilePricingInit();
      },
    });
  }
});
